// extracted by mini-css-extract-plugin
export default {"itemContent":"nXfy1CBY8y","itemContent__text":"iR51__vobI"};